const roleTypeData = ['tooltip', 'dialog'];

export default roleTypeData;
